import React from "react";
import Create from "modules/translations/components/Create";

const TranslationsCreatePage = () => {
  return <Create />;
};

export default TranslationsCreatePage;
